import { serviceRequest } from 'utils/http';
import { ChangeCurrentPasswordDto, Service } from 'common/api';

export function updatePasswordAPI(requestBody: ChangeCurrentPasswordDto) {
  return serviceRequest(() => Service.siteEmployeeControllerUpdateCurrentPassword(requestBody));
}
